import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b3b27fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "capitalize" }
const _hoisted_2 = { class: "capitalize" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "ion-padding-end overflowed-content" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ion-margin-top" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_empty_container = _resolveComponent("empty-container")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_dictionary = _resolveComponent("dictionary")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && Object.keys(_ctx.vocabulary).length)
      ? (_openBlock(), _createBlock(_component_ion_row, {
          key: 1,
          class: "display-flex ion-justify-content-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, {
              sizeXs: "12",
              sizeSm: "12",
              sizeMd: "10",
              sizeLg: "8",
              sizeXl: "8"
            }, {
              default: _withCtx(() => [
                (_ctx.showDefaultMessage)
                  ? (_openBlock(), _createBlock(_component_ion_card, {
                      key: 0,
                      class: "ion-padding"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_empty_container, { message: _ctx.defaultMessage }, null, 8, ["message"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vocabulary.definitions, (definition) => {
                  return (_openBlock(), _createElementBlock("view", {
                    key: definition.id
                  }, [
                    _createVNode(_component_ion_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_1, _toDisplayString(definition.meaning), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(" Examples ")
                              ]),
                              _: 1
                            }),
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(definition.examples, (example, exampleIndex) => {
                                return (_openBlock(), _createElementBlock("li", { key: exampleIndex }, [
                                  _createElementVNode("span", _hoisted_2, _toDisplayString(example), 1)
                                ]))
                              }), 128))
                            ]),
                            (definition.notes.length)
                              ? (_openBlock(), _createElementBlock("view", _hoisted_3, [
                                  _createVNode(_component_ion_card_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Notes ")
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(definition.notes, (note, noteIndex) => {
                                      return (_openBlock(), _createElementBlock("li", { key: noteIndex }, [
                                        _createElementVNode("span", {
                                          innerHTML: note,
                                          class: "capitalize link-container image-container"
                                        }, null, 8, _hoisted_4)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (definition.externalLinks.length)
                              ? (_openBlock(), _createElementBlock("view", _hoisted_5, [
                                  _createVNode(_component_ion_card_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" External Links ")
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(definition.externalLinks, (externalLink, externalLinkIndex) => {
                                      return (_openBlock(), _createElementBlock("li", { key: externalLinkIndex }, [
                                        _createElementVNode("a", {
                                          href: externalLink,
                                          target: "_blank"
                                        }, [
                                          _createElementVNode("span", null, [
                                            _createTextVNode(" Browse the link "),
                                            _createVNode(_component_font_awesome_icon, { icon: _ctx.faExternalLinkAlt }, null, 8, ["icon"])
                                          ])
                                        ], 8, _hoisted_6)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128)),
                (_ctx.vocabulary.linkerWords.length)
                  ? (_openBlock(), _createBlock(_component_ion_card, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(" Relatable Words ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vocabulary.linkerWords, (linkerWord, linkerWordIndex) => {
                              return (_openBlock(), _createElementBlock("view", { key: linkerWordIndex }, [
                                _createVNode(_component_ion_chip, {
                                  class: "linker-word-chip",
                                  onClick: ($event: any) => (_ctx.$router.push(`/linker-words/${linkerWord}`))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(linkerWord), 1),
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: _ctx.faExternalLinkAlt,
                                      class: "firecracker-primary-color-icon"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.vocabulary.genericNotes.length)
                  ? (_openBlock(), _createBlock(_component_ion_card, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(" Generic Notes ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vocabulary.genericNotes, (genericNote, genericNotesIndex) => {
                                return (_openBlock(), _createElementBlock("li", { key: genericNotesIndex }, [
                                  _createElementVNode("span", {
                                    innerHTML: genericNote,
                                    class: "capitalize link-container image-container"
                                  }, null, 8, _hoisted_8)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.vocabulary.genericExternalLinks.length)
                  ? (_openBlock(), _createBlock(_component_ion_card, { key: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(" Generic External Links ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vocabulary.genericExternalLinks, (genericExternalLink, genericExternalLinkIndex) => {
                                return (_openBlock(), _createElementBlock("li", { key: genericExternalLinkIndex }, [
                                  _createElementVNode("a", {
                                    href: genericExternalLink,
                                    target: "_blank"
                                  }, [
                                    _createElementVNode("span", null, [
                                      _createTextVNode(" Browse the link "),
                                      _createVNode(_component_font_awesome_icon, { icon: _ctx.faExternalLinkAlt }, null, 8, ["icon"])
                                    ])
                                  ], 8, _hoisted_9)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isLoading && Object.keys(_ctx.vocabulary).length)
                  ? (_openBlock(), _createBlock(_component_dictionary, {
                      key: 4,
                      word: _ctx.vocabulary.word,
                      "label-alignment": 'left'
                    }, null, 8, ["word"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_fab, {
      vertical: "bottom",
      horizontal: "end",
      slot: "fixed"
    }, {
      default: _withCtx(() => [
        (!_ctx.isLoading && Object.keys(_ctx.vocabulary).length && !_ctx.disableInsertingIntoLeitnerBox)
          ? (_openBlock(), _createBlock(_component_ion_fab_button, {
              key: 0,
              "aria-label": "Make flashcard",
              size: "small",
              color: "lightest",
              disabled: _ctx.disableBoxInsertionButton,
              onClick: _ctx.insertIntoLeitnerBox
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.isInLeitnerBox ? _ctx.faHeartSolid : _ctx.faHeartRegular,
                  class: "firecracker-primary-color-icon leitner-icon"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        _hoisted_10,
        _createVNode(_component_ion_fab_button, {
          "aria-label": "Edit",
          size: "small",
          color: "warning",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/vocabulary/update/${_ctx.vocabulary.id}`)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.faPencilAlt }, null, 8, ["icon"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}